import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RouteLoaderService {
  readonly active = signal(false);

  private readonly MIN_MS = 1000;
  private startedAt = 0;

  show() {
    this.startedAt = performance.now();
    if (!this.active()) this.active.set(true);
  }

  hide() {
    const elapsed = performance.now() - this.startedAt;
    const wait = Math.max(0, this.MIN_MS - elapsed);
    setTimeout(() => this.active.set(false), wait);
  }
}
